import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { defineMessages } from 'react-intl';
const CONNECTOR_TRIGGER_LIMIT_ERROR_CODE = 'AUTOMATION_CONNECTOR_TRIGGER_LIMIT';
export const AUTOMATIONS_MANAGEMENT_PATH = '/computer/automations';
export const connectorTriggerLimitMessages = defineMessages({
    title: {
        defaultMessage: 'Connector trigger limit reached',
        id: '3978b21c04',
        description: 'Title shown when an automation connector trigger cannot be added',
    },
    description: {
        defaultMessage: 'Remove an automation to free a connector trigger slot.',
        id: 'dad77cf7de',
        description: 'Recovery guidance shown when the connector trigger limit is reached',
    },
    descriptionWithUsage: {
        defaultMessage: "You're using {currentCount, number} of {limit, plural, one {# connector trigger slot} other {# connector trigger slots}}. Remove an automation to free a slot.",
        id: '9acac76cec',
        description: 'Usage and recovery guidance shown when the connector trigger limit is reached',
    },
    manageAutomations: {
        defaultMessage: 'Manage automations',
        id: '5872a20d9b',
        description: 'Link to the automation management view from a connector trigger limit error',
    },
});
export const automationQuotaManagementSelectedEvent = EVENT_PAYLOAD;
export function getConnectorTriggerLimitError(error) {
    if (!(error instanceof ApiClientsError) ||
        error.detail?.error_code !== CONNECTOR_TRIGGER_LIMIT_ERROR_CODE) {
        return null;
    }
    return {
        pool: typeof error.detail.pool === 'string' ? error.detail.pool : null,
        limit: typeof error.detail.limit === 'number' ? error.detail.limit : null,
        currentCount: typeof error.detail.current_count === 'number' ? error.detail.current_count : null,
    };
}
//# sourceMappingURL=connectorTriggerLimitError.js.map